import * as React from "react";
import Iconify from "../../iconify/Iconify";
import IconCode from "../../../lib/iconCode";
import { useRouter } from "next/router";
import useAuth from "@/src/lib/hooks/useAuth";
import CustomTooltip from "@/src/lib/ui/customTooltip";
import Link from "next/link";

export default function Navigation({ menuItems }) {
    const { isLoggedIn } = useAuth();
    const router = useRouter();

    const menuClickHandler = (item, level) => {
        if (!item?.url) return;
        const skipUrls = ["locate-us"];
        const isLocationUrls = skipUrls.some((segment) =>
            item.url.includes(segment)
        );
        if (isLocationUrls && (level == 1 || level == 2)) {
            return;
        }

        if (item.url.startsWith("http://") || item.url.startsWith("https://")) {
            window.open(item.url, "_blank");
        } else {
            if (isLocationUrls) {
                window.location.pathname = item.url;
            } else {
                router.push(item.url);
            }
        }
    };

    const renderMenuItem = (item, level) => {
        const hasChildren = item?.children?.length > 0;
        const isOverflow = level === 1 && (item?.children?.length || 0) > 6;

        return (
            <li key={item?.id || item?.name}>
                <h4 onClick={() => menuClickHandler(item, level)}>
                    <span
                        role="menuitem"
                        className="text-black hover:text-primary cursor-pointer"
                    >
                        {item?.name}
                    </span>
                </h4>

                {hasChildren && (
                    <Iconify
                        icon={IconCode.arrowDown}
                        width="24px"
                        className="absolute right-1.5 top-1/2 -translate-y-1/2 text-primary"
                    />
                )}

                {hasChildren && (
                    <ul className={isOverflow ? "overflow-auto h-80" : ""}>
                        {item.children.map((child) =>
                            renderMenuItem(child, level + 1)
                        )}
                    </ul>
                )}
            </li>
        );
    };

    return (
        <div className="bg-white border-t border-solid border-t-gray-200 relative z-10 border-b-2 border-b-primary md:block hidden py-2 md:h-[48px] h-auto">
            <div className="max-w-6xl mx-auto">
                <div className="dropdown-menu flex items-center justify-between py-1">
                    <div className="flex items-center text-black">
                        {menuItems?.menus?.menu?.items?.map((item, i) => {
                            if (!item) return null;
                            const hasChildren = item?.children?.length > 0;

                            return (
                                <div key={i}>
                                    <div
                                        key={item?.id}
                                        className="md:px-6 px-4 border-0 border-transparent menu-hover cursor-pointer"
                                    >
                                        <h4 className="text-base font-medium flex justify-center items-center hover:text-primary">
                                            <span
                                                className="whitespace-nowrap"
                                                onClick={() =>
                                                    menuClickHandler(item, 0)
                                                }
                                            >
                                                {item?.name}
                                            </span>
                                            {hasChildren && (
                                                <Iconify
                                                    icon={IconCode.arrowDown}
                                                    width="24px"
                                                    className="ml-1 text-primary"
                                                />
                                            )}
                                        </h4>

                                        {hasChildren && (
                                            <ul className="absolute menu--ul last:border-0">
                                                {item.children.map((child) =>
                                                    renderMenuItem(child, 1)
                                                )}
                                            </ul>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    <CustomTooltip
                        title={isLoggedIn ? "My Reports" : "Online Report"}
                    >
                        <Link
                            className="text-primary font-medium border border-primary border-solid px-3 rounded-md cursor-pointer hover:bg-primary hover:text-white"
                            sx={{ fontSize: "15px" }}
                            href={
                                isLoggedIn
                                    ? "/my-account/my-orders"
                                    : "/online-reports"
                            }
                            passHref
                        >
                            {isLoggedIn ? "My Report" : "Online Report"}
                        </Link>
                    </CustomTooltip>
                </div>
            </div>
        </div>
    );
}
